
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form20";
const form20State = namespace("Form20");

import { form20DataInfoType } from '@/types/Information/Form20';
import Form20Layout from "./Form20Layout.vue";

@Component({
    components:{        
        Form20Layout
    }
})
export default class Form20 extends Vue {
    
    @form20State.State
    public currentNoticeOfObjectionToWithdrawalId: string;

    @form20State.State
    public form20Info: form20DataInfoType;

    @form20State.Action
    public UpdateForm20Info!: (newForm20Info: form20DataInfoType) => void

    result = {} as form20DataInfoType;
    dataReady = false;
    printReady = false;
   
    mounted(){
        this.dataReady = false;
        this.printReady = false;       
        this.getForm20Data(); 
    }   

    public navigateToSubmitPage(){
        this.$emit('navigateToSubmitPage')
    }
           
    public onPrint() { 
        const pdf_type = "FORM"
        const pdf_name = "form20-" + this.currentNoticeOfObjectionToWithdrawalId;
        const el= document.getElementById("print");

      
        const bottomLeftText = `"COURT OF APPEAL FOR BRITISH COLUMBIA                    www.bccourts.ca/Court_of_Appeal/"`;
        const bottomRightText = `" "`;        
        const url = '/form20/form-print/'+this.currentNoticeOfObjectionToWithdrawalId+'/?name=' + pdf_name + '&pdf_type='+pdf_type+'&version=1.0&noDownload=true'
        const pdfhtml = Vue.filter('printPdf')(el.innerHTML, bottomLeftText, bottomRightText );

        const body = {
            'html':pdfhtml,
            'json_data':this.result
        }       
        
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }  

        this.$http.post(url,body, options)
        .then(res => {
            this.$emit('pdfReady')                       
            this.printReady = true;                
        },err => {
            console.error(err);        
        });
    }

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="FORM20"
        const url = '/form20/form-print/'+this.currentNoticeOfObjectionToWithdrawalId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }

    public navigateToEditPage() {
        this.$router.push({name: "fill-form20" })
    }
 
    public getForm20Data() {        
       
        this.$http.get('/form20/forms/'+this.currentNoticeOfObjectionToWithdrawalId)
        .then((response) => {
            if(response?.data?.data){            
                            
                this.result = response.data.data
                this.result.completionDate = Vue.filter('beautify-date-dd/mm/yyyy')(response.data.modified);
               
                this.UpdateForm20Info(this.result)                         
                this.dataReady = true;
                Vue.nextTick(()=> this.onPrint())
            }
                
        },(err) => {
            console.log(err)        
        });      
    }
}
